import { forwardRef } from 'react'

import { IconProps, IconVariants } from '../IconVariants'
const InformationIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size, ...props }, ref) => {
  return (
    <svg
      aria-hidden="true"
      className={IconVariants({
        class: className,
        size,
      })}
      fill="none"
      height="1em"
      ref={ref}
      viewBox="0 0 24 24"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M13.1982 9.43519C13.2327 9.39198 13.25 9.31482 13.25 9.2037V7.2963C13.25 7.18518 13.2327 7.10803 13.1982 7.06482C13.1637 7.02161 13.1021 7 13.0133 7H10.9867C10.8979 7 10.8363 7.02161 10.8018 7.06482C10.7673 7.10803 10.75 7.18518 10.75 7.2963V9.2037C10.75 9.31482 10.7673 9.39198 10.8018 9.43519C10.8363 9.4784 10.8979 9.5 10.9867 9.5H13.0133C13.1021 9.5 13.1637 9.4784 13.1982 9.43519ZM10.8103 10.7914C10.7701 10.819 10.75 10.8684 10.75 10.9394V16.8106C10.75 16.8816 10.7701 16.931 10.8103 16.9586C10.8506 16.9862 10.9224 17 11.0259 17H12.9741C13.0776 17 13.1494 16.9862 13.1897 16.9586C13.2299 16.931 13.25 16.8816 13.25 16.8106V10.9394C13.25 10.8684 13.2299 10.819 13.1897 10.7914C13.1494 10.7638 13.0776 10.75 12.9741 10.75H11.0259C10.9224 10.75 10.8506 10.7638 10.8103 10.7914ZM12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <mask
        height={20}
        id="mask0_3_1188"
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
        width={20}
        x={2}
        y={2}
      >
        <path
          clipRule="evenodd"
          d="M13.1982 9.43519C13.2327 9.39198 13.25 9.31482 13.25 9.2037V7.2963C13.25 7.18518 13.2327 7.10803 13.1982 7.06482C13.1637 7.02161 13.1021 7 13.0133 7H10.9867C10.8979 7 10.8363 7.02161 10.8018 7.06482C10.7673 7.10803 10.75 7.18518 10.75 7.2963V9.2037C10.75 9.31482 10.7673 9.39198 10.8018 9.43519C10.8363 9.4784 10.8979 9.5 10.9867 9.5H13.0133C13.1021 9.5 13.1637 9.4784 13.1982 9.43519ZM10.8103 10.7914C10.7701 10.819 10.75 10.8684 10.75 10.9394V16.8106C10.75 16.8816 10.7701 16.931 10.8103 16.9586C10.8506 16.9862 10.9224 17 11.0259 17H12.9741C13.0776 17 13.1494 16.9862 13.1897 16.9586C13.2299 16.931 13.25 16.8816 13.25 16.8106V10.9394C13.25 10.8684 13.2299 10.819 13.1897 10.7914C13.1494 10.7638 13.0776 10.75 12.9741 10.75H11.0259C10.9224 10.75 10.8506 10.7638 10.8103 10.7914ZM12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </mask>
      <g mask="url(#mask0_3_1188)" />
    </svg>
  )
})
InformationIcon.displayName = 'InformationIcon'
export default InformationIcon
